import styled from 'styled-components'

export const AppLogoWrap = styled.div`
	display: flex;
	cursor: pointer;
`
